





































































































































import { Component, Vue, Mixins, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import store from "@/store";
import DrawsSetting from "./DrawsSettings.vue";
import PotentialSwitch from "@/components/common/edit/PotentialSwitch.vue";
import DashLine from "@/components/common/edit/DashLine.vue";
import ImageCutUpload from "@/components/common/edit/ImageCutUpload.vue";
import getUrlParam from "@/common/utils/getUrlParam";
import { resolveBoundaryValue } from '@/common/utils/format'

@Component({
  components: {
    "potential-switch": PotentialSwitch,
    "draws-setting": DrawsSetting,
    "dash-line": DashLine,
    "image-upload": ImageCutUpload
  }
})
export default class PrizeProgram extends Vue {
  @Getter("gachaTypeParameter") gachaTypeParameter!: object;

  oldList: Array<any> = this.$store.state.oldPrizeList;

  checkWinningProbability(winningProbability: number) {
    if (/((^-[1-9]\d*)|^0)(\.\d{1,2}){0,2}$/.test(String(winningProbability))) {
      Vue.$toast.error("奖品中奖概率不能输入负数");
    }
  }

  handleDeletePrizeProListItem(itemIndex: number, item: any) {
    if (item.id) {
      Vue.$toast.error("活动发布后奖品可新增，但不可删除");
      return;
    }
    store.dispatch("handleDeletePrizeProListItem", itemIndex);
  }

  handleDeletePrizeImg(imgIndex: number) {
    store.dispatch("handleDeletePrizeImg", imgIndex);
  }

  addPrizePicture() {
    store.dispatch("addPrizePicture", {
      name: "",
      img: "",
      num: "",
      winningProbability: "",
      description: ""
    });
  }

  handleDeletePrizeImage(index: number) {
    store.dispatch("handleDeletePrizeImage", index);
  }

  changePrizeImg(imgUrl: string, index: number) {
    store.dispatch("changePrizeItem", { img: imgUrl, index, name: "img" });
  }

  changePrizeNum(e: any, index: number) {
    const num = resolveBoundaryValue(e.target.value, false);
    if (
      this.$store.state.oldPrizeList[index] &&
      Number(num) <
        Number(this.$store.state.oldPrizeList[index].num) &&
      getUrlParam("type") === "reEdit"
    ) {
      Vue.$toast.error("活动发布后奖品数量只能增加不能减少");
      store.dispatch("changeSubtractPrizeLength",true);
      return;
    }

    store.dispatch("changePrizeItem", {
      num: num,
      index,
      name: "num"
    });
    store.dispatch("changeSubtractPrizeLength",false);

  }
}
